function getHHmmssTimestampFromSeconds(totalSeconds: number) {
  return [Math.floor(totalSeconds / 3600), Math.floor((totalSeconds % 3600) / 60), totalSeconds % 60]
    .map((element) => String(element).padStart(2, '0'))
    .join(':')
}

export default getHHmmssTimestampFromSeconds
